import { useEffect, useState } from "react";
import {
  Image,
  Row,
  Col,
  Button,
  Modal,
  Table,
  Alert,
} from "react-bootstrap";

export function CygnusCustomMappingModal(props)  {

  const [requiredMappingsData, setRequiredMappingsData] = useState([]);


  return (
    <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    backdrop="static"
    centered
    className="mapping-modal"
    scrollable="false"
    style={{height: '80vh',}}
    
>
    <Modal.Header className="mapping-modal-header" closeButton>
    <div> <h5> Cygnus Custom Mappings </h5> <br></br>
     <p style={{ color: 'blue' }}> <i> Use these placeholders if required based on the description. </i></p>
     </div>
    </Modal.Header>
    <Modal.Body className="mapping-modal">
      <br></br>  <hr></hr>
      <Table striped bordered hover>
      <thead>
            <tr>
              <th>#</th>
                <th>{props.sourceVendor}</th>
                <th>{props.destinationVendor}</th>
            </tr>
           
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>CYG_EMPTY_STRING</td>
              <td>Reprsents empty string</td>
            </tr>
            <tr>
              <td>2</td>
              <td>CYG_SPACE</td>
              <td>Represents space</td>
            </tr>
            <tr>
              <td>2</td>
              <td>CYG_CURRENT_TIME</td>
              <td>Represents current time</td>
            </tr>

         

        </tbody>
        </Table>
    </Modal.Body>
    <Modal.Footer className="action-footer">
        <Button onClick={props.onHide}>
          Close
        </Button>
    </Modal.Footer>
  </Modal>

  
  )
}
